import { Component, OnInit } from "@angular/core";

@Component({
  selector: "ngx-terms-and-conditions",
  templateUrl: "./vta.terms-and-conditions.component.html",
  styleUrls: ["./vta.terms-and-conditions.component.scss"],
  standalone: false,
})
export class TermsAndConditionsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
